import BootstrapField from '../utility/BootstrapField';
// import moment from 'moment';
// import CloneDeep from 'lodash.clonedeep';
// import DeepDiff from 'deep-diff';


// As private as it gets.
// let originalLaneClosureRequestBlockSidewalkData = null;

export default class LaneClosureRequestBlockSidewalk {
	constructor(data) {
		if (!data) {
			data = {};
		}
		if (data.useTestData) {
			data = {
			}

		}
			// each lane entry contains: lane_id, peakId, peakReason

		Object.assign(this, {
			sidewalkId: new BootstrapField({
				value: data.sidewalkId || null,
			})
			,inEffect: new BootstrapField({
				value:  typeof data.inEffect === 'number' ? data.inEffect:  null,
			})
			,isDeleted: false
		});

		// Keep a record of the old data. (used for the hasChanges() method)
		// originalLaneClosureRequestBlockSidewalkData = CloneDeep(this);
	}

	validate() {
		let errors = [];
		let flag = true;

		for (let field in this) {
			if (this[field] instanceof BootstrapField) {
				let result = this[field].validate();
				if (result === false) {
					errors.push(field);
					flag = false;
				}
			}
		}
		return flag;
	}

	getRawValue() {
		return getRawValue(this);
		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			}
			else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getRawValue(obj[key][arrKey]));
						}
					}
					else {
						value[key] = getRawValue(obj[key]);
					}
				}
			}
			else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

	getValue() {
		return getValue(this);
		function getValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getValue();
			}
			else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getValue(obj[key][arrKey]));
						}
					}
					else {
						value[key] = getValue(obj[key]);
					}
				}
			}
			else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}


	hasChanges() {
		// var differences = DeepDiff.diff(originalLaneClosureBlockLaneData.gSidewalkwValue(),  this.getRawValue());
		// return !IsEqual(originalLaneClosureBlockLaneData.gSidewalkwValue(), this.getRawValue());
		return false;
	}
	revertChanges() {
		// this.constructor(originalLaneClosureBlocSidewalkeData);
	}
	saveChanges() {
		// originalLaneClosureRequestBlockSidewalkData = CloneDeep(this);
	}
}